import React from 'react';
import { Route } from 'react-router-dom';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import InterviewParticipant from './interview-participant';
import InterviewParticipantDetail from './interview-participant-detail';
import InterviewParticipantUpdate from './interview-participant-update';
import InterviewParticipantDeleteDialog from './interview-participant-delete-dialog';

const InterviewParticipantRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<InterviewParticipant />} />
    <Route path="new" element={<InterviewParticipantUpdate />} />
    <Route path=":id">
      <Route index element={<InterviewParticipantDetail />} />
      <Route path="edit" element={<InterviewParticipantUpdate />} />
      <Route path="delete" element={<InterviewParticipantDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default InterviewParticipantRoutes;
